import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { IOException3fje1ukjwthwb as IOException } from '../../../../../okio-parent-okio/okio/NonJvmPlatform.mjs';
import { RuntimeException1r3t0zl97011n as RuntimeException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { firstOrNull1982767dljvdy as firstOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ApolloNetworkExceptionClass;
function ApolloNetworkException() {
  if (ApolloNetworkExceptionClass === VOID) {
    class $ extends ApolloException() {
      static t47(message, platformCause) {
        message = message === VOID ? null : message;
        platformCause = platformCause === VOID ? null : platformCause;
        var $this = this.e4d(message, platformCause instanceof Error ? platformCause : null);
        captureStack($this, $this.s47_1);
        $this.r47_1 = platformCause;
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloNetworkException', $.t47);
    ApolloNetworkExceptionClass = $;
  }
  return ApolloNetworkExceptionClass;
}
var OfflineExceptionClass;
function OfflineException() {
  if (OfflineExceptionClass === VOID) {
    class $ extends IOException() {
      static i4d() {
        OfflineException_instance = null;
        var $this = this.s3z('The device is offline');
        OfflineException_instance = $this;
        captureStack($this, $this.h4d_1);
        return $this;
      }
      toString() {
        return 'OfflineException';
      }
      hashCode() {
        return -155984151;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OfflineException()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'OfflineException');
    OfflineExceptionClass = $;
  }
  return OfflineExceptionClass;
}
var OfflineException_instance;
function OfflineException_getInstance() {
  if (OfflineException_instance === VOID)
    OfflineException().i4d();
  return OfflineException_instance;
}
var ApolloExceptionClass;
function ApolloException() {
  if (ApolloExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static e4d(message, cause) {
        message = message === VOID ? null : message;
        cause = cause === VOID ? null : cause;
        var $this = this.nd(message, cause);
        captureStack($this, $this.d4d_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloException');
    ApolloExceptionClass = $;
  }
  return ApolloExceptionClass;
}
var JsonDataExceptionClass;
function JsonDataException() {
  if (JsonDataExceptionClass === VOID) {
    class $ extends ApolloException() {
      static n47(message) {
        var $this = this.e4d(message);
        captureStack($this, $this.m47_1);
        return $this;
      }
    }
    initMetadataForClass($, 'JsonDataException');
    JsonDataExceptionClass = $;
  }
  return JsonDataExceptionClass;
}
var DefaultApolloExceptionClass;
function DefaultApolloException() {
  if (DefaultApolloExceptionClass === VOID) {
    class $ extends ApolloException() {
      static c45(message, cause) {
        message = message === VOID ? null : message;
        cause = cause === VOID ? null : cause;
        var $this = this.e4d(message, cause);
        captureStack($this, $this.b45_1);
        return $this;
      }
    }
    initMetadataForClass($, 'DefaultApolloException', $.c45);
    DefaultApolloExceptionClass = $;
  }
  return DefaultApolloExceptionClass;
}
var ApolloHttpExceptionClass;
function ApolloHttpException() {
  if (ApolloHttpExceptionClass === VOID) {
    class $ extends ApolloException() {
      static q4d(statusCode, headers, body, message, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.e4d(message, cause);
        captureStack($this, $this.p4d_1);
        $this.m4d_1 = statusCode;
        $this.n4d_1 = headers;
        $this.o4d_1 = body;
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloHttpException');
    ApolloHttpExceptionClass = $;
  }
  return ApolloHttpExceptionClass;
}
var RouterErrorClass;
function RouterError() {
  if (RouterErrorClass === VOID) {
    class $ extends ApolloException() {
      static w4d(errors) {
        var tmp0_safe_receiver = firstOrNull(errors);
        var $this = this.e4d("Router error(s) (first: '" + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y46_1) + "')");
        captureStack($this, $this.v4d_1);
        $this.u4d_1 = errors;
        return $this;
      }
    }
    initMetadataForClass($, 'RouterError');
    RouterErrorClass = $;
  }
  return RouterErrorClass;
}
var SubscriptionOperationExceptionClass;
function SubscriptionOperationException() {
  if (SubscriptionOperationExceptionClass === VOID) {
    class $ extends ApolloException() {
      static c4e(operationName, payload) {
        var $this = this.e4d('Operation error ' + operationName);
        captureStack($this, $this.b4e_1);
        $this.a4e_1 = payload;
        return $this;
      }
    }
    initMetadataForClass($, 'SubscriptionOperationException');
    SubscriptionOperationExceptionClass = $;
  }
  return SubscriptionOperationExceptionClass;
}
var ApolloGraphQLExceptionClass;
function ApolloGraphQLException() {
  if (ApolloGraphQLExceptionClass === VOID) {
    class $ extends ApolloException() {
      static j45(error) {
        var $this = this.e4d("GraphQL error: '" + error.y46_1 + "'");
        captureStack($this, $this.i45_1);
        $this.g45_1 = error;
        $this.h45_1 = listOf($this.g45_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloGraphQLException');
    ApolloGraphQLExceptionClass = $;
  }
  return ApolloGraphQLExceptionClass;
}
var NullOrMissingFieldClass;
function NullOrMissingField() {
  if (NullOrMissingFieldClass === VOID) {
    class $ extends ApolloException() {
      static u45(message) {
        var $this = this.e4d(message);
        captureStack($this, $this.t45_1);
        return $this;
      }
    }
    initMetadataForClass($, 'NullOrMissingField');
    NullOrMissingFieldClass = $;
  }
  return NullOrMissingFieldClass;
}
var NoDataExceptionClass;
function NoDataException() {
  if (NoDataExceptionClass === VOID) {
    class $ extends ApolloException() {
      static p45(cause) {
        var $this = this.e4d('No data was found', cause);
        captureStack($this, $this.o45_1);
        return $this;
      }
    }
    initMetadataForClass($, 'NoDataException');
    NoDataExceptionClass = $;
  }
  return NoDataExceptionClass;
}
var JsonEncodingExceptionClass;
function JsonEncodingException() {
  if (JsonEncodingExceptionClass === VOID) {
    class $ extends ApolloException() {
      static u4c(message) {
        var $this = this.e4d(message);
        captureStack($this, $this.t4c_1);
        return $this;
      }
    }
    initMetadataForClass($, 'JsonEncodingException');
    JsonEncodingExceptionClass = $;
  }
  return JsonEncodingExceptionClass;
}
var ApolloWebSocketClosedExceptionClass;
function ApolloWebSocketClosedException() {
  if (ApolloWebSocketClosedExceptionClass === VOID) {
    class $ extends ApolloException() {
      static j4e(code, reason, cause) {
        reason = reason === VOID ? null : reason;
        cause = cause === VOID ? null : cause;
        var $this = this.e4d("WebSocket Closed code='" + code + "' reason='" + reason + "'", cause);
        captureStack($this, $this.i4e_1);
        $this.g4e_1 = code;
        $this.h4e_1 = reason;
        return $this;
      }
    }
    initMetadataForClass($, 'ApolloWebSocketClosedException');
    ApolloWebSocketClosedExceptionClass = $;
  }
  return ApolloWebSocketClosedExceptionClass;
}
//region block: exports
export {
  ApolloException as ApolloException16lek20l78zc3,
  ApolloGraphQLException as ApolloGraphQLException2qazyzs4ebcad,
  ApolloHttpException as ApolloHttpException3o30u8ntkffuh,
  ApolloNetworkException as ApolloNetworkException3denf70pfh242,
  ApolloWebSocketClosedException as ApolloWebSocketClosedException26hvn543pf46i,
  DefaultApolloException as DefaultApolloException8w3ielfxng0h,
  JsonDataException as JsonDataException2rdtm884tky1l,
  JsonEncodingException as JsonEncodingException1gbe1fu68vssf,
  NoDataException as NoDataException34qvcinicy2ih,
  NullOrMissingField as NullOrMissingField1bkks6typ2v8h,
  RouterError as RouterError3i6hxcnqsy5l3,
  SubscriptionOperationException as SubscriptionOperationException3t8cqqpx8bt9j,
  OfflineException_getInstance as OfflineException_getInstanceq1tpn78onqx1,
};
//endregion

//# sourceMappingURL=Exceptions.mjs.map
